import Styles from "../Styles";
import { View, Text } from "@react-pdf/renderer";
import { AttorneyLabelLineRow, LabelLineRow } from "./FormFields";

const Lines = ({ styles, count = 2 }) => (
  <View>
    {Array.from({ length: count }).map((_, i) => (
      <View key={i} style={{ ...styles.line, marginBottom: 5 }} />
    ))}
  </View>
);

const AttorneySet = ({ styles }) => (
  <View style={{ ...styles.row }}>
    <View style={styles.fieldColNumber}>
      <Text style={styles.ButtonTextSmall}>Attorney Name</Text>
      <Lines styles={styles} count={5} />
    </View>

    <View style={styles.fieldColNumber}>
      <Text style={styles.ButtonTextSmall}>Attorney Email</Text>
      <Lines styles={styles} count={5} />
    </View>

    <View style={styles.fieldColExpiry}>
      <Text style={styles.ButtonTextSmall}>Attorney Phone Number</Text>
      <Lines styles={styles} count={5} />
    </View>
  </View>
);




const PowerOfAttorney = ({
  primaryColor = "081e56",
  logo = "",
  tradingName,
  regulatoryText,
  userEmail,
  userName,
}) => {
  const styles = Styles(primaryColor);
  return (
    <View style={{ ...styles.FlexStartColumn, gap: 0 }}>
      <Text style={styles.ContentSemiBold}>Power of Attorney</Text>
      <View style={styles.panel}>
        {/* <Text style={{ ...styles.ButtonTextSmall, marginBottom: 4 }}>
          A Lasting Power of Attorney (LPA) is a legal document that lets
          someone (the donor) appoint one or more people (attorneys) to make
          decisions on their behalf. There are two types:
        </Text>
        <Text style={{ ...styles.ButtonTextSmall, marginBottom: 4 }}>
          1. Financial Decisions: Allows attorneys to manage bank accounts,
          property, investments, and other financial matters.
        </Text>
        <Text style={{ ...styles.ButtonTextSmall, marginBottom: 4 }}>
          2. Health and Care Decisions: Allows attorneys to make decisions about
          medical treatment, care, and living arrangements.
        </Text>
        <Text style={{ ...styles.ButtonTextSmall, marginBottom: 4 }}>
          Both types must be registered with the Office of the Public Guardian
          to be valid. The donor can choose to have one or both types, and
          attorneys can be the same or different people.
        </Text> */}
      </View>
      {/* Financial Decisions Section */}
      <View style={styles.panel}>
        <AttorneyLabelLineRow
          styles={styles}
          label="Do you have a Lasting Power of Attorney for Financial Decisions?"
        />
        <Text style={{ ...styles.ButtonTextSmall, marginBottom: 4 }}>
          If yes, please provide details of the attorney(s) below.
        </Text>
        {/* <LabelLineRow styles={styles} label="Attorney Name" />
        <LabelLineRow styles={styles} label="Attorney Email" />
              <LabelLineRow styles={styles} label="Attorney Phone Number" /> */}
        <AttorneySet styles={styles} />
      </View>
      {/* Health and Care Decisions Section */}
      <View style={styles.panel}>
        <AttorneyLabelLineRow
          styles={styles}
          label="Do you have a Lasting Power of Attorney for Health and Care Decisions?"
        />
        <Text style={{ ...styles.ButtonTextSmall, marginBottom: 4 }}>
          If yes, please provide details of the attorney(s) below.
        </Text>
        <AttorneySet styles={styles} />
      </View>
    </View>
  );
};

export default PowerOfAttorney;
